var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChatBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_199",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 199",
    transform: "translate(14400.5 351.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_231",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 231",
    width: 25,
    height: 25,
    transform: "translate(-14400.5 -351.5)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "chat-centered",
    transform: "translate(-14400 -351.4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_228",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 228",
    width: 24,
    height: 24,
    transform: "translate(0 0.4)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M34.006,58.592a1.558,1.558,0,0,1-1.32-.741l-1.429-2.394H25.539A1.544,1.544,0,0,1,24,53.911V41.546A1.544,1.544,0,0,1,25.539,40H42.473a1.544,1.544,0,0,1,1.539,1.546V53.911a1.544,1.544,0,0,1-1.539,1.546H36.748L35.33,57.844A1.561,1.561,0,0,1,34.006,58.592ZM25.539,41.546V53.911h5.725a1.535,1.535,0,0,1,1.318.758L34,57.049l0,0a.01.01,0,0,0,.008,0l1.419-2.378a1.532,1.532,0,0,1,1.313-.752h5.726V41.546Z",
    transform: "translate(-21.806 -36.344)",
    fill: "#242323"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBlack);
export default __webpack_public_path__ + "static/media/chat_black.91e4f6321ffaa74ff2b3dd356ed56ad3.svg";
export { ForwardRef as ReactComponent };